import {createContext} from "react";


const EcsContext = createContext({
    ecs: null,
    setEcs: () => {
    }
});
export default EcsContext;